import { createSlice } from "@reduxjs/toolkit";
import helper from "../../Helper";
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
  loading: false,
  userRes: [],
  loginRes: [],
  logoutRes: [],
  activationRes: [],
  error: "",
};



const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    newUser: (state, action) => {
      state.userRes = action.payload;
    },
    activationUser: (state, action) => {
      state.activationRes = action.payload;
    },
    loginUser: (state, action) => {
      state.loginRes = action.payload;
    },
    logoutuser: (state, action) => {
      state.logoutRes = action.payload;
    },
  },
});

export const { newUser, activationUser, loginUser, logoutuser } =
  registerSlice.actions;
export default registerSlice.reducer;

export const addNewUser =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API.userregister}`,
          data
        );
        callback(response);
        dispatch(newUser(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const activateMail =
  (id, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API.verifyuser}/${id}`
        );
        callback(response);
        dispatch(activationUser(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const login =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(`${frontUrl}/${API.login}`, data);
        callback(response);
        dispatch(loginUser(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const logout =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(`${frontUrl}/${API.LOGOUT}`, data);
        callback(response);
        dispatch(logoutuser(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };
